export default __webpack_public_path__ + "static/media/Logo-Shape-modified.451a835d.png";